import React from 'react';
import { SmartLink } from '../components/SmartLink';
import { UtilityHero } from '../components/utility/UtilityHero';
import { LinkCardGrid } from '../components/utility/LinkCardGrid';
import { popularPages } from '../data/utilityPages';
export function NotFound() {
  return <main className="hero-surface w-full" data-id="element-2102" data-mp="154y0ke574jka">
      <div className="mx-auto max-w-shell px-6 pb-20 pt-16 lg:pb-28 lg:pt-24" data-id="element-2103" data-mp="155qxknecrup8">
        <UtilityHero titleId="not-found-heading" display="404" title="We couldn’t find that page" subtitle="The page may have moved or no longer exists." data-id="element-2104" data-mp="1a4u3sb62k6ys">
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-2105" data-mp="1jtlrg743k53w">
            <SmartLink href="/" className="inline-flex h-12 w-full items-center justify-center rounded-[7px] bg-brand px-6 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover sm:w-auto" data-id="element-2106" data-mp="1nvp3oxylbdq8">
              Go to homepage
            </SmartLink>
            <SmartLink href="/contact" className="inline-flex h-12 w-full items-center justify-center rounded-[7px] border border-ink/20 bg-white px-6 text-[15px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink/45 sm:w-auto" data-id="element-2107" data-mp="1nxf3ink1nkzr">
              Contact us
            </SmartLink>
          </div>
        </UtilityHero>

        <div className="mx-auto mt-16 max-w-[960px] border-t border-canvas-line pt-12" data-id="element-2108" data-mp="26lab1pp2c2kf">
          <LinkCardGrid headingId="popular-pages" heading="Popular pages" items={popularPages} data-id="element-2109" data-mp="22ki10u8d9tn3" />
        </div>
      </div>
    </main>;
}